import React, { useEffect, useRef, useState } from 'react';
import IMask from 'imask';
import './withdrawal.css';
import { FaAlignLeft, FaSignOutAlt, FaUserAlt } from 'react-icons/fa';
import {
  FiLock, FiCreditCard, FiDollarSign, FiShield, FiRefreshCw, FiArrowRight,
} from 'react-icons/fi';
import Sidebar from './Sidebar';
import { useAuthContext } from '../../Hooks/useAuthContext';
import { Link } from 'react-router-dom';
import TransactionModal from './TransactionModal';
import { toast } from 'wc-toast';

/* ─── SVG card brand strings (unchanged, kept outside component) ─── */
let amex = `<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="amex" fill-rule="nonzero"> <rect id="Rectangle-1" fill="#2557D6" x="0" y="0" width="750" height="471" rx="40"></rect> <path d="M0.002688,221.18508 L36.026849,221.18508 L44.149579,201.67506 L62.334596,201.67506 L70.436042,221.18508 L141.31637,221.18508 L141.31637,206.26909 L147.64322,221.24866 L184.43894,221.24866 L190.76579,206.04654 L190.76579,221.18508 L366.91701,221.18508 L366.83451,189.15941 L370.2427,189.15941 C372.62924,189.24161 373.3263,189.46144 373.3263,193.38516 L373.3263,221.18508 L464.43232,221.18508 L464.43232,213.72973 C471.78082,217.6508 483.21064,221.18508 498.25086,221.18508 L536.57908,221.18508 L544.78163,201.67506 L562.96664,201.67506 L570.98828,221.18508 L644.84844,221.18508 L644.84844,202.65269 L656.0335,221.18508 L715.22061,221.18508 L715.22061,98.67789 L656.64543,98.67789 L656.64543,113.14614 L648.44288,98.67789 L588.33787,98.67789 L588.33787,113.14614 L580.80579,98.67789 L499.61839,98.67789 C486.02818,98.67789 474.08221,100.5669 464.43232,105.83121 L464.43232,98.67789 L408.40596,98.67789 L408.40596,105.83121 C402.26536,100.40529 393.89786,98.67789 384.59383,98.67789 L179.90796,98.67789 L166.17407,130.3194 L152.07037,98.67789 L87.59937,98.67789 L87.59937,113.14614 L80.516924,98.67789 L25.533518,98.67789 L-2.99999999e-06,156.92445 L-2.99999999e-06,221.18508 L0.002597,221.18508 L0.002688,221.18508 Z" id="Path" fill="#FFFFFF"></path> <path d="M749.95644,343.76716 C744.83485,351.22516 734.85504,355.00582 721.34464,355.00582 L680.62723,355.00582 L680.62723,336.1661 L721.17969,336.1661 C725.20248,336.1661 728.01736,335.63887 729.71215,333.99096 C731.18079,332.63183 732.2051,330.65804 732.2051,328.26036 C732.2051,325.70107 731.18079,323.66899 729.62967,322.45028 C728.09984,321.10969 725.87294,320.50033 722.20135,320.50033 C702.40402,319.83005 677.70592,321.10969 677.70592,293.30714 C677.70592,280.56363 685.83131,267.14983 707.95664,267.14983 L749.95379,267.14983 L749.95644,249.66925 L710.93382,249.66925 C699.15812,249.66925 690.60438,252.47759 684.54626,256.84375 L684.54626,249.66925 L626.83044,249.66925 C617.60091,249.66925 606.76706,251.94771 601.64279,256.84375 L601.64279,249.66925 L498.57751,249.66925 L498.57751,256.84375 C490.37496,250.95154 476.53466,249.66925 470.14663,249.66925 L402.16366,249.66925 L402.16366,256.84375 C395.67452,250.58593 381.24357,249.66925 372.44772,249.66925 L296.3633,249.66925 L278.95252,268.43213 L262.64586,249.66925 L148.99149,249.66925 L148.99149,372.26121 L260.50676,372.26121 L278.447,353.20159 L295.34697,372.26121 L364.08554,372.32211 L364.08554,343.48364 L370.84339,343.48364 C379.96384,343.62405 390.72054,343.25845 400.21079,339.17311 L400.21079,372.25852 L456.90762,372.25852 L456.90762,340.30704 L459.64268,340.30704 C463.13336,340.30704 463.47657,340.45011 463.47657,343.92344 L463.47657,372.25587 L635.71144,372.25587 C646.64639,372.25587 658.07621,369.46873 664.40571,364.41107 L664.40571,372.25587 L719.03792,372.25587 C730.40656,372.25587 741.50913,370.66889 749.95644,366.60475 L749.95644,343.76712 L749.95644,343.76716 Z" id="path13" fill="#FFFFFF"></path> </g> </g>`;
let visa = `<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="visa" fill-rule="nonzero"> <rect id="Rectangle-1" fill="#0E4595" x="0" y="0" width="750" height="471" rx="40"></rect> <polygon id="Shape" fill="#FFFFFF" points="278.1975 334.2275 311.5585 138.4655 364.9175 138.4655 331.5335 334.2275"></polygon> <path d="M524.3075,142.6875 C513.7355,138.7215 497.1715,134.4655 476.4845,134.4655 C423.7605,134.4655 386.6205,161.0165 386.3045,199.0695 C386.0075,227.1985 412.8185,242.8905 433.0585,252.2545 C453.8275,261.8495 460.8105,267.9695 460.7115,276.5375 C460.5795,289.6595 444.1255,295.6545 428.7885,295.6545 C407.4315,295.6545 396.0855,292.6875 378.5625,285.3785 L371.6865,282.2665 L364.1975,326.0905 C376.6605,331.5545 399.7065,336.2895 423.6355,336.5345 C479.7245,336.5345 516.1365,310.2875 516.5505,269.6525 C516.7515,247.3835 502.5355,230.4355 471.7515,216.4645 C453.1005,207.4085 441.6785,201.3655 441.7995,192.1955 C441.7995,184.0585 451.4675,175.3575 472.3565,175.3575 C489.8055,175.0865 502.4445,178.8915 512.2925,182.8575 L517.0745,185.1165 L524.3075,142.6875" id="path13" fill="#FFFFFF"></path> <path d="M661.6145,138.4655 L620.3835,138.4655 C607.6105,138.4655 598.0525,141.9515 592.4425,154.6995 L513.1975,334.1025 L569.2285,334.1025 C569.2285,334.1025 578.3905,309.9805 580.4625,304.6845 C586.5855,304.6845 641.0165,304.7685 648.7985,304.7685 C650.3945,311.6215 655.2905,334.1025 655.2905,334.1025 L704.8025,334.1025 L661.6145,138.4655 Z" id="Path" fill="#FFFFFF"></path> <path d="M232.9025,138.4655 L180.6625,271.9605 L175.0965,244.8315 C165.3715,213.5575 135.0715,179.6755 101.1975,162.7125 L148.9645,333.9155 L205.4195,333.8505 L289.4235,138.4655 L232.9025,138.4655" id="path16" fill="#FFFFFF"></path> <path d="M131.9195,138.4655 L45.8785,138.4655 L45.1975,142.5385 C112.1365,158.7425 156.4295,197.9015 174.8155,244.9525 L156.1065,154.9925 C152.8765,142.5965 143.5085,138.8975 131.9195,138.4655" id="path18" fill="#F2AE14"></path> </g> </g>`;
let mastercard = `<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="mastercard" fill-rule="nonzero"> <rect id="Rectangle-1" fill="#000000" x="0" y="0" width="750" height="471" rx="40"></rect> <g id="Group" transform="translate(133.000000, 48.000000)"> <path d="M88.13,373.67 L88.13,348.82 C88.13,339.29 82.33,333.08 72.81,333.08 C67.81,333.08 62.46,334.74 58.73,340.08 C55.83,335.52 51.73,333.08 45.48,333.08 C40.7599149,332.876008 36.2525337,335.054575 33.48,338.88 L33.48,333.88 L25.61,333.88 L25.61,373.64 L33.48,373.64 L33.48,350.89 C33.48,343.89 37.62,340.54 43.42,340.54 C49.22,340.54 52.53,344.27 52.53,350.89 L52.53,373.67 L60.4,373.67 L60.4,350.89 C60.4,343.89 64.54,340.54 70.34,340.54 C76.14,340.54 79.45,344.27 79.45,350.89 L79.45,373.67 L88.13,373.67 Z" id="Shape" fill="#FFFFFF"></path> <g> <rect id="Rectangle-path" fill="#FF5F00" x="170.55" y="32.39" width="143.72" height="234.42"></rect> <path d="M185.05,149.6 C185.05997,103.912554 205.96046,60.7376085 241.79,32.39 C180.662018,-15.6713968 92.8620037,-8.68523415 40.103462,48.4380037 C-12.6550796,105.561241 -12.6550796,193.638759 40.103462,250.761996 C92.8620037,307.885234 180.662018,314.871397 241.79,266.81 C205.96046,238.46936 185.05997,195.290092 185.05,149.6 Z" id="Shape" fill="#EB001B"></path> <path d="M483.26,149.6 C483.30134,206.646679 450.756789,258.706022 399.455617,283.656273 C348.154445,308.606523 287.109181,302.064451 242.26,266.81 C278.098424,238.46936 299.001593,195.290092 299.001593,149.6 C299.001593,103.909908 278.098424,60.7306402 242.26,32.39 C287.109181,-2.86445052 348.154445,-9.40652324 399.455617,15.5049525 C450.756789,40.493978 483.30134,92.5533211 483.26,149.6 Z" id="Shape" fill="#F79E1B"></path> </g> </g> </g> </g>`;

let amex_single = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="750" height="471" viewBox="0 0 750 471"><g><g><path fill="#2557D6" d="M554.594,130.608l-14.521,35.039h29.121L554.594,130.608z M387.03,152.321c2.738-1.422,4.349-4.515,4.349-8.356c0-3.764-1.693-6.49-4.431-7.771c-2.492-1.42-6.328-1.584-10.006-1.584h-25.978v19.523h25.63C380.7,154.134,384.131,154.074,387.03,152.321z M54.142,130.608l-14.357,35.039h28.8L54.142,130.608z"/></g></g></svg>`;
let visa_single = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="750px" height="471px" viewBox="0 0 750 471"><g id="visa"><path fill="#0E4595" d="M278.198,334.228l33.36-195.763h53.358l-33.384,195.763H278.198L278.198,334.228z"/><path fill="#0E4595" d="M524.307,142.687c-10.57-3.966-27.135-8.222-47.822-8.222c-52.725,0-89.863,26.551-90.18,64.604c-0.297,28.129,26.514,43.821,46.754,53.185c20.77,9.597,27.752,15.716,27.652,24.283c-0.133,13.123-16.586,19.116-31.924,19.116c-21.355,0-32.701-2.967-50.225-10.274l-6.877-3.112l-7.488,43.823c12.463,5.466,35.508,10.199,59.438,10.445c56.09,0,92.502-26.248,92.916-66.884c0.199-22.27-14.016-39.216-44.801-53.188c-18.65-9.056-30.072-15.099-29.951-24.269c0-8.137,9.668-16.838,30.559-16.838c17.447-0.271,30.088,3.534,39.936,7.5l4.781,2.259L524.307,142.687"/><path fill="#F2AE14" d="M131.92,138.464H45.879l-0.682,4.073c66.939,16.204,111.232,55.363,129.618,102.415l-18.709-89.96C152.877,142.596,143.509,138.896,131.92,138.464"/></g></svg>`;
let mastercard_single = `<svg xmlns="http://www.w3.org/2000/svg" width="482.51" height="374" viewBox="0 0 482.51 374"><g><rect x="169.81" y="31.89" width="143.72" height="234.42" fill="#ff5f00"/><path d="M317.05,197.6A149.5,149.5,0,0,1,373.79,80.39a149.1,149.1,0,1,0,0,234.42A149.5,149.5,0,0,1,317.05,197.6Z" transform="translate(-132.74 -48.5)" fill="#eb001b"/><path d="M615.26,197.6a148.95,148.95,0,0,1-241,117.21,149.43,149.43,0,0,0,0-234.42,148.95,148.95,0,0,1,241,117.21Z" transform="translate(-132.74 -48.5)" fill="#f79e1b"/></g></svg>`;

const Withdrawal = () => {
  const [sidemenu, setSideMenu] = useState(false);
  const [shouldMenuSlide, setShouldMenuSlide] = useState(false);
  const [dashUser, setdashUser] = useState(false);
  const { user, dispatch } = useAuthContext();

  const [name, setName] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [expirationDate, setExpirationDate] = useState('');
  const [securityCode, setSecurityCode] = useState('');

  const nameRef = useRef(null);
  const cardNumberRef = useRef(null);
  const expirationDateRef = useRef(null);
  const securityCodeRef = useRef(null);
  const ccIconRef = useRef(null);
  const ccSingleRef = useRef(null);
  const creditCardRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ currency: '', amount: '' });

  const handleWithdrawClick = () => {
    if (!name || !cardNumber || !securityCode || !expirationDate || !formData.amount || !formData.currency) {
      toast.error('Please fill in all required fields');
    } else {
      setShowModal(true);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const logout = () => dispatch({ type: 'LOGOUT', payload: null });

  const swapColor = (basecolor) => {
    document.querySelectorAll('.lightcolor').forEach((el) => {
      el.setAttribute('class', 'lightcolor ' + basecolor);
    });
    document.querySelectorAll('.darkcolor').forEach((el) => {
      el.setAttribute('class', 'darkcolor ' + basecolor + 'dark');
    });
  };

  useEffect(() => {
    const cardnumber_mask = new IMask(cardNumberRef.current, {
      mask: [
        { mask: '0000 000000 00000', regex: '^3[47]\\d{0,13}', cardtype: 'american express' },
        { mask: '0000 0000 0000 0000', regex: '^(?:6011|65\\d{0,2}|64[4-9]\\d?)\\d{0,12}', cardtype: 'discover' },
        { mask: '0000 000000 0000', regex: '^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}', cardtype: 'diners' },
        { mask: '0000 0000 0000 0000', regex: '^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}', cardtype: 'mastercard' },
        { mask: '0000 0000 0000 0000', regex: '^4\\d{0,15}', cardtype: 'visa' },
        { mask: '0000 0000 0000 0000', regex: '^62\\d{0,14}', cardtype: 'unionpay' },
        { mask: '0000 0000 0000 0000', cardtype: 'Unknown' },
      ],
      dispatch(appended, dynamicMasked) {
        const number = (dynamicMasked.value + appended).replace(/\D/g, '');
        for (let i = 0; i < dynamicMasked.compiledMasks.length; i++) {
          if (dynamicMasked.compiledMasks[i].regex && number.match(new RegExp(dynamicMasked.compiledMasks[i].regex))) {
            return dynamicMasked.compiledMasks[i];
          }
        }
        return dynamicMasked.compiledMasks[dynamicMasked.compiledMasks.length - 1];
      },
    });

    const expirationdate_mask = new IMask(expirationDateRef.current, {
      mask: 'MM{/}YY',
      blocks: {
        MM: { mask: IMask.MaskedRange, from: 1, to: 12, maxLength: 2 },
        YY: { mask: IMask.MaskedRange, from: 0, to: 99, maxLength: 2 },
      },
    });

    const securitycode_mask = new IMask(securityCodeRef.current, { mask: '0000' });

    const brandMap = {
      'american express': { full: amex, single: amex_single, color: 'green' },
      visa:               { full: visa, single: visa_single, color: 'lime' },
      mastercard:         { full: mastercard, single: mastercard_single, color: 'lightblue' },
    };

    cardnumber_mask.on('accept', () => {
      const brand = cardnumber_mask.masked.currentMask?.cardtype;
      const match = brandMap[brand];
      if (match) {
        ccIconRef.current.innerHTML = match.full;
        ccSingleRef.current.innerHTML = match.single;
        swapColor(match.color);
      } else {
        ccIconRef.current.innerHTML = '';
        ccSingleRef.current.innerHTML = '';
        swapColor('grey');
      }
      const svgnumber = document.getElementById('svgnumber');
      if (svgnumber) {
        svgnumber.innerHTML = cardnumber_mask.value.length === 0
          ? '0123 4567 8910 1112'
          : cardnumber_mask.value;
      }
    });

    expirationdate_mask.on('accept', () => {
      const svgexpire = document.getElementById('svgexpire');
      if (svgexpire) {
        svgexpire.innerHTML = expirationdate_mask.value.length === 0 ? '01/23' : expirationdate_mask.value;
      }
    });

    securitycode_mask.on('accept', () => {
      const svgsecurity = document.getElementById('svgsecurity');
      if (svgsecurity) {
        svgsecurity.innerHTML = securitycode_mask.value.length === 0 ? '985' : securitycode_mask.value;
      }
    });

    return () => {
      cardnumber_mask.destroy();
      expirationdate_mask.destroy();
      securitycode_mask.destroy();
    };
  }, []);

  const handleNameChange = (e) => {
    setName(e.target.value);
    const val = e.target.value || 'John Doe';
    ['svgname', 'svgnameback'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.innerHTML = val;
    });
  };

  const handleFocus = (field) => {
    if (!creditCardRef.current) return;
    if (field === 'securitycode') {
      creditCardRef.current.classList.add('flipped');
    } else {
      creditCardRef.current.classList.remove('flipped');
    }
  };

  return (
    <div className="dashboard">
      {/* ── HEADER ── */}
      <div className="dashboard-header">
        <div className="rights-side">
          <Link to="/" style={{ textDecoration: 'none', color: 'white', cursor: 'pointer' }}>
            <p>{process.env.REACT_APP_APP_NAME}</p>
          </Link>
          <FaAlignLeft
            onClick={() => {
              setShouldMenuSlide(true);
              setSideMenu(!sidemenu);
            }}
          />
        </div>
        <div className="left-side">
          <FaUserAlt onClick={() => setdashUser(!dashUser)} />
        </div>
        {dashUser && (
          <div className="user-menu">
            <Link style={{ textDecoration: 'none', color: '#6e6e6e', marginTop: '.8rem' }} to="/user-profile">
              <p>Profile Overview</p>
            </Link>
            <Link style={{ textDecoration: 'none', color: '#6e6e6e', marginTop: '.8rem' }} to="/profile-setting">
              <p>Profile Settings</p>
            </Link>
            <p className="logout" onClick={logout}>
              <FaSignOutAlt /> Logout
            </p>
          </div>
        )}
      </div>

      {/* ── MAIN ── */}
      <div className="dashboard-main-section">
        {sidemenu && <Sidebar shouldMenuSlide={shouldMenuSlide} onClose={() => setSideMenu(false)} />}

        <div className="withdrawal">
          {/* Page heading */}
          <div className="payment-title">
            <h1>Withdraw Funds</h1>
          </div>

          {/* Two-column grid */}
          <div className="withdrawal-page-grid">

            {/* ── LEFT: Amount + card details form ── */}
            <div className="withdrawal-left-panel">

              {/* Amount section */}
              <div className="withdrawal-section-card">
                <div className="withdrawal-section-card__header">
                  <div className="withdrawal-section-card__header-icon">
                    <FiDollarSign size={16} />
                  </div>
                  <h3>Withdrawal Amount</h3>
                </div>
                <div className="withdrawal-section-card__body">
                  <div className="send-money-grid">
                    <div className="send-money-form-group">
                      <label htmlFor="currency">Currency <span>*</span></label>
                      <select
                        id="currency"
                        value={formData.currency}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>Select currency</option>
                        <option value="USD">USD — US Dollar</option>
                        <option value="EUR">EUR — Euro</option>
                        <option value="GBP">GBP — British Pound</option>
                      </select>
                    </div>
                    <div className="send-money-form-group">
                      <label htmlFor="amount">Amount <span>*</span></label>
                      <input
                        type="number"
                        id="amount"
                        placeholder="0.00"
                        value={formData.amount}
                        onChange={handleChange}
                        required
                        min="0"
                        step="0.01"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Card details section */}
              <div className="withdrawal-section-card">
                <div className="withdrawal-section-card__header">
                  <div className="withdrawal-section-card__header-icon">
                    <FiCreditCard size={16} />
                  </div>
                  <h3>Card Details</h3>
                </div>
                <div className="withdrawal-section-card__body">
                  <div className="form-container">
                    {/* Name */}
                    <div className="field-container">
                      <label htmlFor="name">Cardholder Name</label>
                      <input
                        id="name"
                        maxLength="26"
                        type="text"
                        placeholder="Full name on card"
                        ref={nameRef}
                        value={name}
                        onChange={handleNameChange}
                        onFocus={() => handleFocus('name')}
                      />
                    </div>

                    {/* Card number */}
                    <div className="field-container">
                      <label htmlFor="cardnumber">Card Number</label>
                      <input
                        id="cardnumber"
                        type="text"
                        placeholder="0000 0000 0000 0000"
                        inputMode="numeric"
                        ref={cardNumberRef}
                        value={cardNumber}
                        onChange={(e) => setCardNumber(e.target.value)}
                        onFocus={() => handleFocus('cardnumber')}
                      />
                      <svg
                        id="ccicon"
                        className="ccicon"
                        width="750"
                        height="471"
                        viewBox="0 0 750 471"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        ref={ccIconRef}
                      />
                    </div>

                    {/* Expiry */}
                    <div className="field-container">
                      <label htmlFor="expirationdate">Expiry (MM/YY)</label>
                      <input
                        id="expirationdate"
                        type="text"
                        placeholder="MM/YY"
                        inputMode="numeric"
                        ref={expirationDateRef}
                        value={expirationDate}
                        onChange={(e) => setExpirationDate(e.target.value)}
                        onFocus={() => handleFocus('expirationdate')}
                      />
                    </div>

                    {/* CVV + Submit */}
                    <div className="field-container">
                      <label htmlFor="securitycode">CVV / CVC</label>
                      <input
                        id="securitycode"
                        type="text"
                        placeholder="•••"
                        inputMode="numeric"
                        ref={securityCodeRef}
                        value={securityCode}
                        onChange={(e) => setSecurityCode(e.target.value)}
                        onFocus={() => handleFocus('securitycode')}
                      />
                    </div>
                  </div>

                  {/* Submit */}
                  <div style={{ marginTop: '1.5rem' }}>
                    <button onClick={handleWithdrawClick}>
                      <FiArrowRight size={15} />
                      Confirm Withdrawal
                    </button>
                  </div>

                  {/* Security badges */}
                  <div className="withdrawal-security">
                    <div className="withdrawal-security__badge">
                      <FiLock size={13} />
                      SSL Encrypted
                    </div>
                    <div className="withdrawal-security__badge">
                      <FiShield size={13} />
                      PCI Compliant
                    </div>
                    <div className="withdrawal-security__badge">
                      <FiRefreshCw size={13} />
                      Secure Transfer
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── RIGHT: Card visual ── */}
            <div className="withdrawal-right-panel">
              <div className="withdrawal-card-wrapper">
                {/* Card flip view */}
                <div className="container" style={{ position: 'relative', padding: 0, height: '251px' }}>
                  <div
                    className="creditcard"
                    ref={creditCardRef}
                    onClick={() => creditCardRef.current?.classList.toggle('flipped')}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="front">
                      <div id="ccsingle" ref={ccSingleRef}></div>
                      <svg
                        version="1.1"
                        id="cardfront"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 750 471"
                        style={{ enableBackground: 'new 0 0 750 471' }}
                        xmlSpace="preserve"
                      >
                        <g id="Front">
                          <g id="CardBackground">
                            <g id="Page-1_1_">
                              <g id="amex_1_">
                                <path
                                  id="Rectangle-1_1_"
                                  className="lightcolor grey"
                                  d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40 C0,17.9,17.9,0,40,0z"
                                />
                              </g>
                            </g>
                            <path
                              className="darkcolor greydark"
                              d="M750,431V193.2c-217.6-57.5-556.4-13.5-750,24.9V431c0,22.1,17.9,40,40,40h670C732.1,471,750,453.1,750,431z"
                            />
                          </g>
                          <text transform="matrix(1 0 0 1 60.106 295.0121)" id="svgnumber" className="st2 st3 st4">
                            0123 4567 8910 1112
                          </text>
                          <text transform="matrix(1 0 0 1 54.1064 428.1723)" id="svgname" className="st2 st5 st6">
                            JOHN DOE
                          </text>
                          <text transform="matrix(1 0 0 1 54.1074 389.8793)" className="st7 st5 st8">
                            cardholder name
                          </text>
                          <text transform="matrix(1 0 0 1 479.7754 388.8793)" className="st7 st5 st8">
                            expiration
                          </text>
                          <text transform="matrix(1 0 0 1 65.1054 241.5)" className="st7 st5 st8">
                            card number
                          </text>
                          <g>
                            <text transform="matrix(1 0 0 1 574.4219 433.8095)" id="svgexpire" className="st2 st5 st9">
                              01/23
                            </text>
                            <text transform="matrix(1 0 0 1 479.3848 417.0097)" className="st2 st10 st11">VALID</text>
                            <text transform="matrix(1 0 0 1 479.3848 435.6762)" className="st2 st10 st11">THRU</text>
                            <polygon className="st2" points="554.5,421 540.4,414.2 540.4,427.9" />
                          </g>
                          <g id="cchip">
                            <g>
                              <path
                                className="st2"
                                d="M168.1,143.6H82.9c-10.2,0-18.5-8.3-18.5-18.5V74.9c0-10.2,8.3-18.5,18.5-18.5h85.3 c10.2,0,18.5,8.3,18.5,18.5v50.2C186.6,135.3,178.3,143.6,168.1,143.6z"
                              />
                            </g>
                            <g>
                              <rect x="82" y="70" className="st12" width="1.5" height="60" />
                              <rect x="167.4" y="70" className="st12" width="1.5" height="60" />
                              <path
                                className="st12"
                                d="M125.5,130.8c-10.2,0-18.5-8.3-18.5-18.5c0-4.6,1.7-8.9,4.7-12.3c-3-3.4-4.7-7.7-4.7-12.3 c0-10.2,8.3-18.5,18.5-18.5s18.5,8.3,18.5,18.5c0,4.6-1.7,8.9-4.7,12.3c3,3.4,4.7,7.7,4.7,12.3 C143.9,122.5,135.7,130.8,125.5,130.8z"
                              />
                              <rect x="82.8" y="82.1" className="st12" width="25.8" height="1.5" />
                              <rect x="82.8" y="117.9" className="st12" width="26.1" height="1.5" />
                              <rect x="142.4" y="82.1" className="st12" width="25.8" height="1.5" />
                              <rect x="142" y="117.9" className="st12" width="26.2" height="1.5" />
                            </g>
                          </g>
                        </g>
                        <g id="Back"></g>
                      </svg>
                    </div>

                    <div className="back">
                      <svg
                        version="1.1"
                        id="cardback"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 750 471"
                        style={{ enableBackground: 'new 0 0 750 471' }}
                        xmlSpace="preserve"
                      >
                        <g id="Back">
                          <g id="Page-1_2_">
                            <g id="amex_2_">
                              <path
                                id="Rectangle-1_2_"
                                className="darkcolor greydark"
                                d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40 C0,17.9,17.9,0,40,0z"
                              />
                            </g>
                          </g>
                          <rect y="61.6" className="st2" width="750" height="78" />
                          <g>
                            <path
                              className="st3"
                              d="M701.1,249.1H48.9c-3.3,0-6-2.7-6-6v-52.5c0-3.3,2.7-6,6-6h652.1c3.3,0,6,2.7,6,6v52.5 C707.1,246.4,704.4,249.1,701.1,249.1z"
                            />
                            <rect x="42.9" y="198.6" className="st4" width="664.1" height="10.5" />
                            <rect x="42.9" y="224.5" className="st4" width="664.1" height="10.5" />
                            <path
                              className="st5"
                              d="M701.1,184.6H618h-8h-10v64.5h10h8h83.1c3.3,0,6-2.7,6-6v-52.5C707.1,187.3,704.4,184.6,701.1,184.6z"
                            />
                          </g>
                          <text transform="matrix(1 0 0 1 621.999 227.2734)" id="svgsecurity" className="st6 st7">
                            985
                          </text>
                          <g className="st8">
                            <text transform="matrix(1 0 0 1 518.083 280.0879)" className="st9 st6 st10">
                              security code
                            </text>
                          </g>
                          <rect x="58.1" y="378.6" className="st11" width="375.5" height="13.5" />
                          <rect x="58.1" y="405.6" className="st11" width="421.7" height="13.5" />
                          <text transform="matrix(1 0 0 1 59.5073 228.6099)" id="svgnameback" className="st12 st13">
                            John Doe
                          </text>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>

                <p className="card-flip-hint">
                  Click the card to flip and view the back
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && <TransactionModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Withdrawal;